/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["colorpicker-panel{display:block;width:230px;height:277px}colorpicker-panel>.trigger{display:block}"];
export { styles as styles };
